/**
 * 관리자 표 모양 — 흰 카드 안의 표. 머리줄은 작은 회색 글자와 밑줄, 행 사이 얇은 선, 올리면 살짝 밝아진다.
 * 표마다 같은 클래스를 써서 모든 목록 화면이 같은 모양이 되게 한다.
 */
export const tableStyles = {
  card: 'overflow-x-auto rounded-2xl border border-foreground/[0.06] bg-card shadow-[0_1px_2px_rgba(0,0,0,0.03)]',
  table: 'w-full text-sm',
  head: 'border-b border-foreground/10 text-left',
  th: 'px-5 py-3 text-xs font-medium whitespace-nowrap text-muted-foreground',
  row: 'border-t border-foreground/[0.06] transition-colors first:border-t-0 hover:bg-foreground/[0.02]',
  td: 'px-5 py-4 align-middle',
} as const;
